module.exports = __webpack_public_path__ + "img/005bb7b.png";